import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TransactionsStore {
  setCreateDisputeDetails(details: any) {
    localStorage.setItem(
      'createDisputeDetails',
      JSON.stringify(details)
    );
  }

  getCreateDisputeDetails() {
    return JSON.parse(localStorage.getItem('createDisputeDetails'));
  }

  setTransactionDetails(transactionDetails: any) {
    localStorage.setItem(
      'transactionDetails',
      JSON.stringify(transactionDetails)
    );
  }

  getTransactionDetails() {
    return JSON.parse(localStorage.getItem('transactionDetails'));
  }

  setGeneralReports(generalReports: any) {
    localStorage.setItem(
      'generalReportsDetails',
      JSON.stringify(generalReports)
    );
  }

  getGeneralReports() {
    return JSON.parse(localStorage.getItem('generalReportsDetails'));
  }

  setCashiersReports(cashiersReports: any) {
    localStorage.setItem(
      'cashiersReportsDetails',
      JSON.stringify(cashiersReports)
    );
  }

  getCashiersReports() {
    return JSON.parse(localStorage.getItem('cashiersReportsDetails'));
  }

  setCashiersBankTransferReports(reports: any) {
    localStorage.setItem(
      'cashiersBankTransferReports',
      JSON.stringify(reports)
    );
  }

  getCashiersBankTransferReports() {
    return JSON.parse(localStorage.getItem('cashiersBankTransferReports'));
  }

  setCashiersUssdReports(cashiersUssdReports: any) {
    localStorage.setItem(
      'cashiersUssdReports',
      JSON.stringify(cashiersUssdReports)
    );
  }

  getCashiersUssdReports() {
    return JSON.parse(localStorage.getItem('cashiersUssdReports'));
  }

  setTransactionCount(transactionCount: number) {
    localStorage.setItem('transactionCount', transactionCount.toString());
  }

  getTransactionCount() {
    return JSON.parse(localStorage.getItem('transactionCount'));
  }

  setTransactionStatus(status: any) {
    localStorage.setItem('transactionStatus', JSON.stringify(status));
  }

  getTransactionStatus() {
    return JSON.parse(localStorage.getItem('transactionStatus'));
  }

  setFilterQueryString(queryString: string) {
    localStorage.setItem('filterQueryString', queryString);
  }

  getFilterQueryString() {
    return localStorage.getItem('filterQueryString');
  }

  setIsFilterApplied(applied: boolean) {
    localStorage.setItem('isFilterApplied', applied.toString());
  }

  getIsFilterApplied() {
    return localStorage.getItem('isFilterApplied');
  }

  setIsTransactionResolved(resolved: boolean) {
    localStorage.setItem('isTransactionResolved', resolved.toString());
  }

  getIsTransactionResolved() {
    return localStorage.getItem('isTransactionResolved');
  }
}
